module.exports = __webpack_public_path__ + "img/youicon1.e684add9.svg";